import {
  Directive,
  HostBinding,
  HostListener,
  Inject,
  Optional,
  NgZone,
  OnInit,
  ElementRef,
  ViewContainerRef,
  AfterViewInit,
} from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY,
  MatTooltip,
  MatTooltipDefaultOptions,
} from '@angular/material/tooltip';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher, ScrollStrategy } from '@angular/cdk/overlay';
import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Platform } from '@angular/cdk/platform';

@Directive({
    selector: '[cropFieldLabel]',
    standalone: false
})
export class FieldCropLabelDirective extends MatTooltip implements OnInit, AfterViewInit {
  labelInnerText = '';
  tooltipBaseClass = 'mat-form-field-label-tooltip';

  @HostBinding('class') elementClass: string;
  @HostListener('mouseenter') onMouseenter(): void {
    if (this.isTextCropped()) {
      this.message = this.labelInnerText;
      this.show();
    }
  }
  @HostListener('mouseleave') onMouseleave(): void {
    if (this.isTextCropped()) {
      this.hide();
    }
  }

  constructor(
    overlay: Overlay,
    scrollDispatcher: ScrollDispatcher,
    viewContainerRef: ViewContainerRef,
    ngZone: NgZone,
    platform: Platform,
    ariaDescriber: AriaDescriber,
    focusMonitor: FocusMonitor,
    @Optional() dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY)
    scrollStrategy: ScrollStrategy,
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    defaultOptions: MatTooltipDefaultOptions,
    private elementRef: ElementRef,
  ) {
    super(
      overlay,
      elementRef,
      scrollDispatcher,
      viewContainerRef,
      ngZone,
      platform,
      ariaDescriber,
      focusMonitor,
      scrollStrategy,
      dir,
      defaultOptions,
      {},
    );
  }

  ngOnInit(): void {
    this.position = 'above';
  }

  // overwriting ngAfterViewInit() to prevent unnecessary logic from super class
  // eslint-disable-next-line
  ngAfterViewInit(): void {}

  private isTextCropped(): boolean {
    const labelElement: HTMLElement = this.getChildByLocalName(this.elementRef.nativeElement, 'mat-label');
    this.adjustTooltipPosition();
    this.labelInnerText = labelElement.innerText;
    const { offsetWidth, scrollWidth } = labelElement.parentElement;

    return offsetWidth < scrollWidth;
  }

  private adjustTooltipPosition(): void {
    this.tooltipClass = `${this.tooltipBaseClass} ${
      this.elementRef.nativeElement.classList.contains('mat-form-field-hide-placeholder') ? 'hide-placeholder-mode' : ''
    }`;
  }

  private getChildByLocalName(el: HTMLElement, target: string): HTMLElement {
    let searchElement: HTMLElement = null;
    const search = (parent: HTMLElement): void => {
      if (parent.children.length && !searchElement) {
        for (const child of Array.from(parent.children as HTMLCollection)) {
          if (child.localName === target) {
            searchElement = child as HTMLElement;
            break;
          }
          search(child as HTMLElement);
        }
      }
    };
    search(el);

    return searchElement;
  }
}
